export const TOOLTIP_DESCRIPTION = 'Do not include amounts paid to owner-employees, self-employed individuals, or general partners.';
export const TOOLTIP_NAME = 'total-cash-compensation-tooltip';
